import Collapse, { Panel } from 'rc-collapse';
import React from 'react';
import styled from 'styled-components';

import './infoPanel.scss';
import './closeModalLayout.scss';

const Table = styled.table`
  margin: 0 !important;
`;

const LeftTd = styled.td`
  width: 10px;
`;

const RightTd = styled.td`
  text-align: right;
`;

function InfoPanel(props) {
  const { title, extra, rows = [], show = true, isShowRows = true, panelKey, children, headerClassName } = props;

  if (!show) {
    return null;
  }

  return (
    <Collapse collapsible="header" defaultActiveKey={[panelKey]}>
      <Panel
        key={panelKey}
        showArrow={true}
        headerClass={`headerInfoPanel block-datacollapse-header ${headerClassName}`}
        className="block-datacollapse-container infoPanel-datacollapse-container"
        header={title}
        extra={extra}>
        <Table className="table infoPanel-table">
          <tbody>
            {isShowRows && rows
              .filter(({ value }) => value !== null)
              .map((row, idx) => (
                <tr key={row.title}>
                  <LeftTd>
                    <p>{idx + 1}</p>
                  </LeftTd>
                  <td>
                    <p>{row.title}</p>
                  </td>
                  <RightTd>
                    <p>{row.value} руб.</p>
                  </RightTd>
                </tr>
              ))}
          </tbody>
          {children}
        </Table>
      </Panel>
    </Collapse>
  );
}

export default InfoPanel;
